module.exports = "public/SafeTripBuilder - Risk Categories Manifest.pdf";